module.exports = __webpack_public_path__ + "static/img/mid.39017c93.png";